
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/valentinesday",
      function () {
        return require("private-next-pages/[lang]/legal/valentinesday/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/valentinesday"])
      });
    }
  